import { httpGetAndParse } from '../../../../utils/fetchService';

export const fetchSltAmountDetails = ({ taxYear, period, entityId, accountGroup }) =>
  httpGetAndParse({
    route: `/api/entities/slt-amount-details/${taxYear}/${period}/${entityId}/${accountGroup}`,
    errorMessage: 'Fetching SLT amount details failed',
  });
